import { useMemo } from 'react';
import type { EvCalculationViewEnum } from './utils';

interface UseValidateDebouncedKwhCost {
  kwhCost?: number;
  debouncedKwhCost?: number;
  view: EvCalculationViewEnum;
}

const useValidateDebouncedKwhCost = ({
  kwhCost,
  debouncedKwhCost,
  view,
}: UseValidateDebouncedKwhCost): boolean => {
  const valid = useMemo(() => {
    // Handle cases where value is undefined or null up front
    const isKwhCostValid = typeof kwhCost === 'number' && !Number.isNaN(kwhCost);
    const isDebouncedValid =
      typeof debouncedKwhCost === 'number' && !Number.isNaN(debouncedKwhCost);

    // If both are invalid, treat as "bothNaN"
    const bothInvalid = !isKwhCostValid && !isDebouncedValid;

    // Loading only applies for views other than "own" or if kwhCost is set
    const debouncedLoading =
      view !== 'own' || kwhCost ? !bothInvalid && kwhCost !== debouncedKwhCost : false;
    return debouncedLoading;
  }, [kwhCost, debouncedKwhCost, view]);
  return valid;
};

export default useValidateDebouncedKwhCost;
